export const CONFIRM_SUCCESS_MESSAGE = "The event was confirmed successfully";
export const CANCEL_SUCCESS_MESSAGE = "The event was canceled successfully";
export const CREATE_EVENT_SUCCESS_MESSAGE =
  "The event was successfully scheduled";
export const UPDATE_EVENT_SUCCESS_MESSAGE =
  "The event was successfully updated";
